import { useMemo } from 'react';
import { MarketplaceDomain, MarketplaceDomainWithCustodian } from 'new/entities/MarketplaceDomain';
import { useMarketplaceDomains } from 'new/hooks/adapters/useMarketplaceDomains';

function mergeDomainsWithCustodianFlag(
  custodianDomains: MarketplaceDomain[] | undefined = [],
  allDomains: MarketplaceDomain[] | undefined = [],
): MarketplaceDomainWithCustodian[] {
  const safeCustodianDomains = custodianDomains ?? [];
  const custodianIds = new Set(
    safeCustodianDomains.map((d) => d?.id).filter((id): id is number => id != null),
  );
  const safeAllDomains = allDomains ?? [];
  return safeAllDomains.map((domain) => ({
    ...domain,
    hasCustodianAccess: custodianIds.has(domain?.id),
  }));
}

export function useUserDomains() {
  const { domainEntitiesById: allDomains, availableDomainEntities: custodianDomains } =
    useMarketplaceDomains();

  const domains = useMemo(
    () => mergeDomainsWithCustodianFlag(custodianDomains, allDomains),
    [allDomains, custodianDomains],
  );

  return { domains };
}
